import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, LogIn } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function AdminLoginPage() {
    const { user, login } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({ email: "", password: "" });
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    if (user) return <Navigate to="/admin" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        const res = await login(form.email, form.password);
        setLoading(false);
        if (res.ok) navigate("/admin");
        else setError(res.error);
    };

    return (
        <main className="min-h-screen bg-bg flex items-center justify-center px-6" data-testid="admin-login-page">
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                className="w-full max-w-md glass rounded-3xl p-10"
            >
                <div className="w-14 h-14 rounded-2xl bg-gold/10 border border-gold/20 flex items-center justify-center mx-auto mb-6">
                    <Lock size={22} className="text-gold" />
                </div>
                <h1 className="font-display text-3xl text-center tracking-tight mb-2">
                    Админ панел
                </h1>
                <p className="text-ink-muted text-center text-sm mb-8">
                    Konstantin.mobile.bg
                </p>

                <form onSubmit={submit} className="space-y-5">
                    <label className="block bg-surface2 border border-line rounded-xl px-5 py-4 hover:border-gold/40 transition-all">
                        <span className="block text-[10px] uppercase tracking-[0.25em] text-ink-subtle">Имейл</span>
                        <input
                            required
                            type="email"
                            value={form.email}
                            onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
                            className="w-full mt-1 bg-transparent text-sm focus:outline-none"
                            data-testid="admin-login-email"
                        />
                    </label>
                    <label className="block bg-surface2 border border-line rounded-xl px-5 py-4 hover:border-gold/40 transition-all">
                        <span className="block text-[10px] uppercase tracking-[0.25em] text-ink-subtle">Парола</span>
                        <input
                            required
                            type="password"
                            value={form.password}
                            onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
                            className="w-full mt-1 bg-transparent text-sm focus:outline-none"
                            data-testid="admin-login-password"
                        />
                    </label>

                    {error && (
                        <div className="text-sm text-red-400" data-testid="admin-login-error">
                            {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full inline-flex items-center justify-center gap-3 bg-gold hover:bg-gold-light text-bg font-medium px-8 py-4 rounded-full transition-all disabled:opacity-60"
                        data-testid="admin-login-submit"
                    >
                        {loading ? "Влизане…" : (<>Вход <LogIn size={16} /></>)}
                    </button>
                </form>
            </motion.div>
        </main>
    );
}
